import Axios  from "axios"

export const getUsers = (users) => async (dispatch) => {
    dispatch({
        type: 'USER_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/admin/user/getall/', {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )      
        if(status===200){            
            dispatch({
                type: 'USERS_GET_SUCCESS',
                payload: data.users
            }) 
        }

    } catch (error) {
        dispatch({
            type: 'USER_ERROR'           
        })         
    }
}

export const getUserDetail = (user) => async (dispatch) => {
    dispatch({
        type: 'USER_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/admin/user/get/'+ user, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )            
        if(status===200){            
            dispatch({
                type: 'USER_GET_DETAIL_SUCCESS',
                payload: data.user
            })             
        }

    } catch (error) {
        dispatch({
            type: 'USER_ERROR'           
        })         
    }
}

export const addUser = (username, password, firstname, lastname, nss, category, dni, address, rol, origen, counter) => async (dispatch) => {
    dispatch({
        type: 'USER_LOADING'
    })
    try {
        const {
            data,
            status
        } = await Axios.post(
            process.env.REACT_APP_DB_ADDRESS + '/api/admin/user/register', {
                username: username,
                password: password,
                firstname: firstname,
                lastname: lastname,
                category: category,
                nss: nss,
                dni: dni,
                address: address,
                rol: rol,
                origen: origen,
                counter: counter
            }, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if (status === 200) {
            let newUser = {
                _id: data.id,
                username: username,
                password: password,
                firstname: firstname,
                lastname: lastname,
                category: category,
                nss: nss,
                dni: dni,
                address: address,
                rol: rol,
                origen: origen,
                counter: counter
            }
            dispatch({
                type: 'USER_ADD_SUCCESS',
                payload: newUser
            })
        }
    } catch (error) {
        dispatch({
            type: 'USER_FAIL'
        })
    }
}

export const editUser = (username, password, firstname, lastname, category, nss, dni, address, rol, origen, counter, idUser) => async (dispatch) => {
    dispatch({
        type: 'USER_LOADING'
    })
    try {
        await Axios.put(
            process.env.REACT_APP_DB_ADDRESS + '/api/admin/user/edit/' + idUser, {
                username: username,
                password: password,
                firstname: firstname,
                lastname: lastname,
                category: category,
                nss: nss,
                dni: dni,
                address: address,
                rol: rol,
                origen: origen,
                counter: counter
            }, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        dispatch({
            type: 'USER_EDIT_SUCCESS',
            payload: {
                username: username,
                password: '',
                firstname: firstname,
                lastname: lastname,
                category: category,
                nss: nss,
                dni: dni,
                address: address,
                rol: rol,
                origen: origen,
                counter: counter,
                _id: idUser
            }
        })
    } catch (error) {
        dispatch({
            type: 'USER_ERROR'
        })
    }
}

export const removeUser = (idUser) => async (dispatch) => {
    try {
        const {
            data,
            status
        } = await Axios.delete(
            process.env.REACT_APP_DB_ADDRESS + '/api/admin/user/remove/' + idUser, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'USER_DELETE_SUCCESS',
                payload: {
                    idUser: idUser,
                    message: data.message,
                    count: data.count
                }
            })
        }else{
            dispatch({
                type: 'USER_DELETE_NOT_SUCCESS',
                payload: {
                    message: data.message,
                    count: data.count
                }
            })
        }
    } catch (error) {
        dispatch({
            type: 'USER_ERROR'
        })
    }
}